import { DetailedHTMLProps, FC, SVGProps } from "react";
export const AppleIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (



<svg className={className} width="24" height="28" viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1772 8.04533C11.0712 8.04533 9.35972 6.78767 7.55722 6.832C5.17722 6.8635 2.99555 8.21217 1.76938 10.3483C-0.700448 14.6358 1.13239 20.9685 3.54155 24.4533C4.72338 26.1497 6.11755 28.0583 7.96555 27.9988C9.73888 27.923 10.4039 26.8473 12.5564 26.8473C14.6926 26.8473 15.2981 27.9988 17.1764 27.9533C19.0862 27.923 20.2984 26.2267 21.4651 24.514C22.8137 22.5447 23.3737 20.6348 23.4041 20.5298C23.3586 20.5147 19.6917 19.1053 19.6474 14.8633C19.6171 11.3167 22.5407 9.62033 22.6772 9.5445C21.0101 7.10617 18.4504 6.83317 17.5555 6.7725C15.2222 6.5905 13.2681 8.04533 12.1772 8.04533ZM16.1182 4.46833C17.1017 3.28767 17.7516 1.63683 17.5707 0C16.1626 0.0606667 14.4651 0.939167 13.4501 2.121C12.5401 3.16633 11.7537 4.84867 11.9649 6.454C13.5259 6.57533 15.1324 5.65133 16.1171 4.4695" fill="black"/>
</svg>

);
